import React from 'react';

import palette from './palette';

interface AnalysisAboutProps {
  // The analysis as users know it, e.g. "NetWAS" or "Sei".
  name: string;
  helpUrl: string;
  children: React.ReactNode;
}

// The info panel beside a job form when no job is selected, shared by
// NetWAS/MAGE-WAS and the DeepSEA family. Paragraphs inside pick up the blurb
// style.
const styles = `
  .analysis-about {
    margin: 50px 10px 0 0;
    padding: 20px 22px 18px;
    background: ${palette.panelBackground};
    border: 1px solid ${palette.border};
    border-left: 3px solid ${palette.accent};
    border-radius: 6px;
    box-shadow: 0 1px 2px ${palette.panelShadow};
  }
  .analysis-about h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: ${palette.heading};
    letter-spacing: .01em;
  }
  .analysis-about p {
    margin: 12px 0 0;
    font-size: 13.5px;
    line-height: 1.65;
    color: ${palette.body};
  }
  .analysis-about-docs {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 18px;
    padding: 8px 13px;
    background: ${palette.cardBackground};
    border: 1px solid ${palette.borderSoft};
    border-radius: 4px;
    color: ${palette.text};
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    transition: border-color .15s ease, background .15s ease,
      box-shadow .15s ease, color .15s ease;
  }
  .analysis-about-docs:hover,
  .analysis-about-docs:focus {
    border-color: ${palette.accent};
    background: ${palette.hoverBackground};
    box-shadow: 0 1px 3px ${palette.hoverShadow};
    color: ${palette.accentDeep};
    text-decoration: none;
  }
`;

function AnalysisAbout({
  name,
  helpUrl,
  children,
}: AnalysisAboutProps): JSX.Element {
  return (
    <div className="analysis-about">
      <style>{styles}</style>
      <h4>{`About ${name}`}</h4>
      {children}
      <a
        className="analysis-about-docs"
        href={helpUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-book" aria-hidden="true" />
        {`Read the ${name} documentation`}
        <i className="fa fa-arrow-right" aria-hidden="true" />
      </a>
    </div>
  );
}

export default AnalysisAbout;
